import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, OnInit } from '@angular/core';
import { NoValue, toEnum } from '@tribeauto/ngx-mobilite-material';
import { Router } from '@angular/router';
import {
  PageRoutingEnum,
  QueryParamsCallBack,
  RedirectModel,
  RedirectQueryParams,
  SubPageRoutingEnum
} from './callback.model';
import { UserService } from '../../user-connection/user.service';
import { map, Observable, of } from 'rxjs';
import { ApplicationStore } from '../../../core/services/application-store.service';
import { AuthenticationService } from '../../authentication/authentication.service';
import { CallbackStore } from './callback-store.service';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'pvmo-callback',
  imports: [],
  template: '',
  styleUrl: './callback.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CallbackComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly applicationStore = inject(ApplicationStore);
  private readonly callbackStore = inject(CallbackStore);
  private readonly authenticationService = inject(AuthenticationService);
  private readonly destroyRef = inject(DestroyRef);
  state = input<string>();
  page: PageRoutingEnum | null = null;
  subPage: SubPageRoutingEnum | NoValue = null;
  id: string | null = null;
  queryParams: QueryParamsCallBack | NoValue = undefined;
  protected readonly userService = inject(UserService);

  constructor() {
    effect(() => {
      const userData = this.applicationStore.instant('userData')();
      if (userData) {
        this.handleRedirection().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
      }
    });
  }

  ngOnInit(): void {
    const localState = this.state();
    const params = localState?.split(';');
    if (params?.[1]) {
      this.id = null;
      this.subPage = null;
      if (params[1] === 'null' || params[1].length > 400) {
        this.page = PageRoutingEnum.ERROR;
      } else {
        const decodeAndCleanParam = decodeURIComponent(params[1].replaceAll('-%', '%'));
        const datas: RedirectModel = JSON.parse(decodeAndCleanParam);
        this.page = toEnum(PageRoutingEnum, datas.page);
        this.id = datas.id ?? '';
        this.subPage = toEnum(SubPageRoutingEnum, datas.subPage ?? '');
        this.queryParams = datas.queryParams;
        this.callbackStore.updateRedirectModel(datas);
      }
    }
  }

  private handleRedirection(): Observable<void> {
    let pageRedirection = '/home';
    if (this.page) {
      if (
        [PageRoutingEnum.ROOT, PageRoutingEnum.CALLBACK, PageRoutingEnum.HOME, PageRoutingEnum.ERROR].includes(
          this.page
        )
      ) {
        this.page = PageRoutingEnum.HOME;
      }
      pageRedirection = '/' + this.page;
      if (this.id) {
        pageRedirection = pageRedirection.concat('/').concat(this.id);
        return this.authenticationService.generateInternalToken(this.id).pipe(
          map(token => {
            if (this.subPage) {
              pageRedirection = pageRedirection.concat('/').concat(this.subPage);
            }
            let queryParams: RedirectQueryParams = { token };
            if (this.queryParams) {
              queryParams = { ...queryParams, ...this.queryParams };
            }
            void this.router.navigate([pageRedirection], {
              queryParams
            });
            return void 0;
          })
        );
      }
    }
    let queryParams: RedirectQueryParams = {};
    if (this.queryParams) {
      queryParams = { ...this.queryParams };
    }
    void this.router.navigate([pageRedirection], { queryParams });
    return of(void 0);
  }
}
